import { DataList } from '@chakra-ui/react'
import { IDataListProps } from '@src/components/DataListComponent/types'
import { NoData } from '@src/components/NoData/NoData'

export interface Props {
    data: IDataListProps[]
}

export const DataListComponent = (props: Props) => {
    if (props.data.length === 0) {
        return <NoData></NoData>
    }

    return (
        <DataList.Root orientation="horizontal">
            {props.data.map((item, index) => (
                <DataList.Item key={index}>
                    {item.label && <DataList.ItemLabel>{item.label}</DataList.ItemLabel>}
                    <DataList.ItemValue>{item.value}</DataList.ItemValue>
                </DataList.Item>
            ))}
        </DataList.Root>
    )
}
